import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiQueryParams, ApiResponse } from "types/api";

import { transformManifestResponse } from "./transformers";
import { Manifest } from "./types";

export const useManifest = (id: string, queryParams?: ApiQueryParams) => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<Manifest>>({
    queryKey: ["manifest", { id }],
    queryFn: async () =>
      transformManifestResponse(
        await dispatch(
          apiThatThrows.getAppManifest.action({
            params: { id },
            queryParams,
          })
        )
      ),
    enabled: Boolean(id),
    retryOnMount: false,
  });
};
